import React from 'react';

const WidgetTabsTab: React.FC = ({ children }) => {
    return <>{ children }</>;
};

export default WidgetTabsTab;
